'use client';

import { useEffect, useState } from 'react';
import HalfWaveBackground from "../svgs/halfcarve";

interface HeroVideoProps {
  title: string;
  videoUrl: string;
  posterUrl?: string;
  preload?: 'none' | 'metadata' | 'auto';
  showWave?: boolean;
  breadcrumbs?: React.ReactNode;
  breadcrumbsClassName?: string;
}

export default function HeroVideo({
  title,
  videoUrl,
  posterUrl,
  preload = 'metadata',
  showWave = true,
  breadcrumbs,
  breadcrumbsClassName = "",
}: HeroVideoProps) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFadeOut(true);
    }, 1000); 

    return () => clearTimeout(timeout);
  }, []);

  return (
    <section className="relative w-full h-[400px] md:h-[500px] lg:h-[650px] overflow-hidden mt-0 mb-16">
      {breadcrumbs && (
        <div
          className={`absolute left-0 right-0 top-[92px] lg:top-[128px] z-20 px-6 sm:px-10 ${breadcrumbsClassName}`}
        >
          {breadcrumbs}
        </div>
      )}
      <div
        className={`absolute inset-0 z-10 flex items-center justify-center transition-opacity duration-500 ${
          fadeOut ? 'opacity-0' : 'opacity-50'
        }`}
      >
        <div className="bg-gradient-to-b from-[#54169C]/90 to-pink-500/90 w-full h-full absolute" />
        <p
          className="text-4xl md:text-5xl lg:text-6xl font-normal text-white relative z-10"
          aria-hidden="true"
        >
          {title}
        </p>
      </div>

      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        poster={posterUrl}
        preload={preload}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {showWave && (
        <div className="absolute bottom-0 w-full hidden sm:block">
          <HalfWaveBackground />
        </div>
      )}
    </section>
  );
}
